import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  SpeechAI,
  SpeechCustomizedSolution,
  SpeechSecurityMeasures,
  SpeechProvenRecord,
  SpeechCompliance,
  SpeechIntegration,
} from "../../../app-constants";
import { Link } from "gatsby";

function Whychoosespeeech() {
  return (
    <section className="voice_services why_choose_speech p-100 overflow-x-hidden">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Why Choose TekRevol For <span>Shopify Ecommerce</span> Website
              Development?
            </h2>
            <p>
              With over a decade of experience, TekRevol is the leading Shopify
              website development company to consult on the best strategy for
              selecting the right plan for your business. We not only assist you
              in selecting the appropriate service package, but we also
              fine-tune your website to guarantee that you get the best value
              for your money.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Customized themes and designs</h5>
                    <p>
                      Our team creates themes and interfaces with your brand in
                      mind to provide an appealing user experience. Every design
                      is tailored to your specific traits and requirements.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Extensive Shopify experience</h5>
                    <p>
                      We provide great and professional services, having gained
                      extensive experience and establishing ourselves as one of
                      the leading Shopify Experts.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Complete solutions</h5>
                    <p>
                      We offer end-to-end Shopify solutions, handling both
                      design and functionality and guarantee successful
                      eCommerce implementation.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Reliable customer support</h5>
                    <p>
                      We provide highly trustworthy, skilled, and prompt
                      Customer Support to ensure that operations run smoothly
                      and efficiently and that all problems are resolved
                      quickly.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Flexible development</h5>
                    <p>
                      We ensure your website adapts to evolving needs and
                      changes. Our customizable solutions easily accommodate
                      updates and new features.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_content">
                    <h5>Shopify Plus Expertise</h5>
                    <p>
                      As experienced Shopify Plus partners, we offer complex and
                      bespoke solutions for expanding businesses. Our experience
                      guarantees efficient service and excellent support for all
                      eCommerce needs.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center mt-sm-3 mt-md-5"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Consultation Today!
            </Link>
          </Col>
        </Row> */}
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
